import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import i18n from "./locale";
import Fcs from '@oasis-games/front-components-succotash'
import MetaInfo from 'vue-meta-info'
Vue.use(MetaInfo)
Vue.use(Fcs)
Vue.config.productionTip = false

new Vue({
  router,
  store,
  i18n,
  render: h => h(App)
}).$mount('#app')
